import React from 'react';
import { useQuery } from '@apollo/client';
import Error from '@xingternal/pages-warning';

import Kununu from './Kununu';
import Header from './components/Header';
import KununuSkeleton from './components/KununuSkeleton';

import KUNUNU_QUERY from './KununuQuery.graphql';
import { NUMBER_OF_REVIEWS_REQUESTED } from './config';
import { KununuData, KununuReviews, KununuQuery } from './types';

type Props = {
  companyId: string;
  pageSlug: string;
  isEditor?: boolean;
};

const KununuContainer = ({ isEditor, companyId, pageSlug }: Props) => {
  const { data, loading, error, refetch } = useQuery<KununuQuery>(
    KUNUNU_QUERY,
    {
      variables: { id: companyId, reviewsLimit: NUMBER_OF_REVIEWS_REQUESTED },
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all',
    }
  );

  const kununuData = data?.company?.kununuData;
  const companyProfileUrl = kununuData?.companyProfileUrl;
  const kununuReviews = data?.company.reviews;

  const renderKununuModule = (
    kununuData: KununuData,
    kununuReviews?: KununuReviews
  ) => {
    const {
      ratingAverage: score,
      recommendationRate: recommendation,
      employerRatingsCount,
      profileUuid,
      benefits = [],
      evaluateProfileUrl,
      kununuCommentsUrl = companyProfileUrl,
    } = kununuData;
    const companyName = String(data?.company.companyName);

    return (
      <Kununu
        isEditor={isEditor}
        pageSlug={pageSlug}
        kununuReviews={kununuReviews}
        score={score}
        recommendation={recommendation}
        companyProfileUrl={companyProfileUrl}
        benefits={benefits}
        companyName={companyName}
        kununuCommentsUrl={String(kununuCommentsUrl)}
        employerRatingsCount={employerRatingsCount}
        profileUuid={profileUuid}
        evaluateProfileUrl={evaluateProfileUrl}
      />
    );
  };

  return (
    <>
      <Header loading={loading} profileUrl={companyProfileUrl} />
      {error && (
        <div data-testid={'errorContainer'}>
          <Error
            headerText="EP_ERROR_HEADER"
            bodyText="EP_ERROR_BODY"
            buttonText="EP_ERROR_RELOAD_CTA"
            onClick={() => refetch()}
          />
        </div>
      )}
      {loading && <KununuSkeleton />}
      {kununuData && renderKununuModule(kununuData, kununuReviews)}
    </>
  );
};

export default KununuContainer;
